module.exports = __webpack_public_path__ + "img/Banner_KNTT6.85257732.png";